/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateScheduleLogDto } from '../../models/create-schedule-log-dto';

export interface ScheduleLogControllerCreate$Params {
  enrollmentScheduleId: string;
  centerId: string;
      body: CreateScheduleLogDto
}

export function scheduleLogControllerCreate(http: HttpClient, rootUrl: string, params: ScheduleLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, scheduleLogControllerCreate.PATH, 'post');
  if (params) {
    rb.query('enrollmentScheduleId', params.enrollmentScheduleId, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

scheduleLogControllerCreate.PATH = '/api/schedule-log';
